import {
  ConditionNodeOutputData,
  DTConditionNode,
  DTNode,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaignVersions/utils/trimDescription';

export function serializeConditionNode(node: DTNode, newNode: ServerNode) {
  const condNode = node as DTConditionNode;

  return {
    ...newNode,
    createAllVariations: condNode.createAllVariations,
    categories: condNode.categories,
    description: trimDescription(newNode.description),
    condKey: condNode.condKey,
    condOperator: condNode.condOperator,
    signalDescription: condNode.signalDescription,
    ...(condNode.randomizeOutputs && {randomizeOutputs: true}),
    outputs: (condNode.outputs as ConditionNodeOutputData[]).map((output) => {
      return {
        nodeId: output.nodeId,
        type: output.type,
        textValues: output.textValues,
        dateValues: output.dateValues,
        numericValues: output.numericValues,
        numbersRange: output.numbersRange,
        datesRange: output.datesRange,
        booleanValue: output.booleanValue,
        id: output.id,
        name: output.name,
      };
    }),
  } as DTConditionNode;
}
